import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { getVerificationCodeAttempt, getVerificationCodeAttemptFailed, getShouldBlockSetupProgress } from '../../selectors/security/SecurityPhoneNumberSetupSelector';
import { changeCodeAttempt, resendCode, codeAttempt } from '../../actions/security/SecurityPhoneNumberActions';
import { getSecurityPhoneNumber } from '../../selectors/security/SecurityPhoneNumberSelector';
import SecurityPhoneNumberRecord from '../../records/security/SecurityPhoneNumber';
import { SECURITY_PHONE_NUMBER } from '../../constants/TwoFactorAuthMethods';
import VerifyAuth from '../../components/VerifyAuth';
import { jsx as _jsx } from "react/jsx-runtime";
class VerifyAuthStepContainer extends Component {
  constructor(...args) {
    super(...args);
    this.handleKeyUp = evt => {
      const {
        shouldBlockSetupProgress
      } = this.props;
      if (!shouldBlockSetupProgress && evt.keyCode === 13) {
        this.handleConfirmSetupStep();
      }
    };
  }
  handleConfirmSetupStep() {
    const {
      verificationCodeAttempt
    } = this.props;
    this.props.codeAttempt(verificationCodeAttempt);
  }
  render() {
    const {
      verificationCodeAttempt,
      invalidVerificationCode,
      securityPhoneNumber
    } = this.props;
    return /*#__PURE__*/_jsx(VerifyAuth, {
      onKeyUp: this.handleKeyUp,
      resendSMSCode: () => this.props.resendCode(securityPhoneNumber),
      verificationCode: verificationCodeAttempt,
      invalidVerificationCode: invalidVerificationCode,
      method: SECURITY_PHONE_NUMBER,
      onVerificationCodeChange: this.props.changeCodeAttempt
    });
  }
}
VerifyAuthStepContainer.propTypes = {
  verificationCodeAttempt: PropTypes.string.isRequired,
  invalidVerificationCode: PropTypes.bool.isRequired,
  shouldBlockSetupProgress: PropTypes.bool.isRequired,
  changeCodeAttempt: PropTypes.func.isRequired,
  resendCode: PropTypes.func.isRequired,
  codeAttempt: PropTypes.func.isRequired,
  securityPhoneNumber: PropTypes.instanceOf(SecurityPhoneNumberRecord).isRequired
};
function mapStateToProps(state) {
  return {
    verificationCodeAttempt: getVerificationCodeAttempt(state),
    invalidVerificationCode: getVerificationCodeAttemptFailed(state),
    shouldBlockSetupProgress: getShouldBlockSetupProgress(state),
    securityPhoneNumber: getSecurityPhoneNumber(state)
  };
}
export default connect(mapStateToProps, {
  changeCodeAttempt,
  resendCode,
  codeAttempt
})(VerifyAuthStepContainer);